/* Native Shopify cart events and access to the existing consent preferences. */
(() => {
  if (window.__pqcCommerceReady) return;
  window.__pqcCommerceReady = true;
  const pendingKey = 'pqc_cart_add_pending_v1';
  const cartVariants = {
    '55274478567765': {productId: '11683407069525', name: 'De Grote Mix Pubquiz', sku: 'PQC-ULTIMATE'},
    '55274478698837': {productId: '11683407135061', name: 'De Team Pubquiz', sku: 'PQC-TEAM'},
  };

  function analyticsAllowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  }

  function clearPendingCartAdds() {
    try { window.sessionStorage.removeItem(pendingKey); } catch { /* Storage may be unavailable. */ }
  }

  // Never store analytics for an action taken without permission, or replay it on a later opt-in.
  document.addEventListener('visitorConsentCollected', () => {
    if (!analyticsAllowed()) clearPendingCartAdds();
  });
  if (window.Shopify?.customerPrivacy && !analyticsAllowed()) clearPendingCartAdds();
  if (!window.Shopify?.customerPrivacy) {
    window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], () => {
      if (!analyticsAllowed()) clearPendingCartAdds();
    });
  }

  function rememberCartAdd(result, body, allowedAtSubmit) {
    if (!allowedAtSubmit || !analyticsAllowed()) return;
    try {
      const variantId = String(result.variant_id || result.id);
      const product = cartVariants[variantId];
      const quantity = Number(body.get('quantity') || 1);
      const price = Number(result.final_price ?? result.price) / 100;
      const currency = window.Shopify?.currency?.active;
      if (!Object.hasOwn(cartVariants, variantId) || !product || variantId !== String(body.get('id')) ||
          !Number.isInteger(quantity) || quantity < 1 || quantity > 99 ||
          !Number.isFinite(price) || price < 0 || !/^[A-Z]{3}$/.test(currency || '')) return;
      const now = Date.now();
      const previous = JSON.parse(window.sessionStorage.getItem(pendingKey) || '[]');
      const pending = Array.isArray(previous)
        ? previous.filter(item => item.createdAt <= now && now - item.createdAt < 300000).slice(-9)
        : [];
      pending.push({
        id: 'pqc_' + window.crypto.randomUUID(), createdAt: now,
        variantId, quantity, price, currency,
      });
      // The pixel reads this on the destination page. Navigation never waits for a Google tag.
      window.sessionStorage.setItem(pendingKey, JSON.stringify(pending));
    } catch { /* Analytics must never block a successful cart operation. */ }
  }

  function statusFor(parent, selector) {
    let status = parent.querySelector(selector);
    if (!status) {
      status = document.createElement('p');
      status.className = 'pqc-small';
      status.setAttribute(selector.slice(1, -1), '');
      status.setAttribute('role', 'status');
      parent.append(status);
    }
    return status;
  }

  // Shared operation: a normal click is handled before it can submit the form.
  // Keep the form action as the no-JavaScript fallback and support other submit routes.
  async function addQuizToCart(event, form, button) {
    if (!form || !button || event.defaultPrevented || !window.fetch || !window.FormData) return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !action.pathname.endsWith('/cart/add')) return;
    event.preventDefault();
    if (form.dataset.pqcAdding === 'true' || button.disabled) return;
    form.dataset.pqcAdding = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    const status = statusFor(form, '[data-pqc-cart-status]');
    status.textContent = '';
    const body = new FormData(form);
    body.delete('return_to');
    const allowedAtSubmit = analyticsAllowed();
    try {
      const response = await window.fetch(action.pathname + '.js', {method: 'POST', headers: {'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json'}, body});
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        status.textContent = typeof result.description === 'string'
          ? result.description
          : 'Toevoegen is niet gelukt. Probeer het nog een keer.';
        return;
      }
      rememberCartAdd(result, body, allowedAtSubmit);
      const target = new URL(form.elements.namedItem('return_to')?.value || action.pathname.replace(/\/add$/, ''), action);
      window.location.assign(target.origin === window.location.origin ? target.href : '/cart');
    } catch {
      // A failed response might still have added the item. Never silently retry a POST.
      status.textContent = 'Toevoegen kon niet worden bevestigd. Bekijk je winkelwagen voordat je opnieuw probeert.';
    } finally {
      delete form.dataset.pqcAdding;
      form.removeAttribute('aria-busy');
      button.disabled = false;
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('.pqc-buy');
    if (!button) return;
    return addQuizToCart(event, button.form, button);
  }, true);

  document.addEventListener('submit', event => {
    const form = event.target;
    return addQuizToCart(event, form, form.querySelector?.('.pqc-buy'));
  });

  let privacyScript;
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-pqc-cookie-settings]');
    if (!button) return;
    const status = statusFor(button.parentElement, '[data-pqc-cookie-status]');
    status.textContent = '';
    button.disabled = true;
    try {
      if (!window.privacyBanner?.showPreferences) {
        privacyScript ||= new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.append(script);
        }).catch(error => { privacyScript = null; throw error; });
        await privacyScript;
      }
      await window.privacyBanner.showPreferences();
    } catch {
      status.textContent = 'Cookie-instellingen konden niet worden geopend. Laad de pagina opnieuw en probeer het nog een keer.';
    } finally {
      button.disabled = false;
    }
  });
})();
